<script setup>
import { computed } from 'vue';
import { Bar, Doughnut } from 'vue-chartjs';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';

const props = defineProps({
  type: { type: String, default: 'bar' },
  data: { type: Object, required: true },
  horizontal: { type: Boolean, default: false },
});

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  Tooltip
);

const component = computed(() => (props.type === 'doughnut' ? Doughnut : Bar));
const options = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  animation: { duration: 0 },
  indexAxis: props.horizontal ? 'y' : 'x',
  plugins: {
    legend: {
      display: props.type === 'doughnut',
      position: 'bottom',
      labels: { usePointStyle: true, boxWidth: 8, color: '#94A3B8' },
    },
  },
  scales:
    props.type === 'doughnut'
      ? undefined
      : {
          x: {
            beginAtZero: true,
            grid: { display: false },
            ticks: { color: '#94A3B8' },
          },
          y: {
            beginAtZero: true,
            grid: { color: 'rgba(148, 163, 184, 0.12)' },
            ticks: { color: '#94A3B8' },
          },
        },
}));
</script>

<template>
  <component :is="component" :data="data" :options="options" />
</template>
